import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import { READOUT_WORD } from '../lib/fleet-machine-panel';
import type { UtilBox } from '../lib/fleetUtilization';
import { RESOURCE_KINDS, resourceBar } from '../lib/machine-bars';

// The details panel's three readouts (#6563, prototype `readout()`): CPU, Memory and Disk,
// each its number, its word and the line under it. The number and the line are the card
// bar's own (`resourceBar`, `lib/machine-bars.ts`), so the card and the panel never read a
// machine two ways; the word names the server's tier (`READOUT_WORD`). Healthy is neutral,
// never green: a tier takes the warning or destructive TEXT colour, and its word always
// says it, so colour never carries the state alone.
//
// The grid only: the Resources section around it, with its range tabs and the charts
// over time, is `<MachineResources/>` (#6565).

export function MachineReadouts(props: { readonly box: UtilBox }): JSX.Element {
  return (
    <div class="machine-panel__readouts">
      <For each={RESOURCE_KINDS}>
        {(kind) => {
          const bar = () => resourceBar(props.box, kind, t);
          const level = () => props.box.verdict.signals[kind].level;
          return (
            <div class="machine-panel__readout" data-tone={bar().tone}>
              <span class="machine-panel__readout-label">{bar().label}</span>
              <span class="machine-panel__readout-value">{bar().value}</span>
              <span class="machine-panel__readout-word">{t(READOUT_WORD[kind][level()])}</span>
              <span class="machine-panel__readout-sub">{bar().tip}</span>
            </div>
          );
        }}
      </For>
    </div>
  );
}
